import React from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import { ResourceType } from 'utils/types';
import useRelations from 'utils/hooks/useRelations';
import useAlerts from 'utils/hooks/useAlerts';
import MemberRelationTable from 'components/MemberRelationTable/MemberRelationTable';
import { createOrgResourceRelationData, useOrgUserRelations } from './queries';


const OrgToUserRelations = ({ breadcrumbs }) => {
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const { users, userRelationQuery, isLoading } = useOrgUserRelations(orgId);

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: userRelationQuery.refetch,
    queryKey: createOrgResourceRelationData(ResourceType.User, orgId),
    onError: addErrorAlert
  });


  return (
    <ContentPage breadcrumb={breadcrumbs} help="organizations/relations">
      { alerts }
      <MemberRelationTable
        orgId={orgId}
        resources={users}
        isLoading={isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />

    </ContentPage>
  );
};

export default OrgToUserRelations;
